import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivateRoute } from './layout/PrivateRoute';
import { PublicRoute } from './layout/PublicRoute';
import Frame from './layout/Frame';
import CredMain from './pages/Cred/CredMain';
import { NotFound } from './pages/Cred/NotFound';
import { NoPermission } from './pages/Cred/NoPermission';
import { OuPreSelection } from './pages/Cred/OuPreSelection';
import { AccountDetail } from './pages/Account/AccountDetail';
import { Account } from './pages/Account/Account';
import { Retention } from '@monorepo/shared';
import { server } from './config/const';
import { LoginRedirect } from './layout/LoginRedirect';
import { Group } from './pages/Group/Group';
import { GroupAccounts } from './pages/Group/GroupAccounts';
import { WebSSH } from './pages/Account/Webssh';
import { Home } from './pages/Home/Home';

interface IProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

function Routing(props: IProps) {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/" element={<Home />} />
          </Route>
          <Route
            path="/login-redirect"
            element={<LoginRedirect />}
            {...props}
          />
          <Route element={<PrivateRoute />}>
            <Route
              path="/group"
              element={
                <Frame {...props} hideFooter>
                  <Group />
                </Frame>
              }
            >
              {/* <Route path="accounts/:groupId?" element={<GroupAccounts />} /> */}
              {/* <Route
                path="accounts/:groupId/:accountId"
                element={<AccountDetail />}
              /> */}
              <Route path="accounts?" element={<GroupAccounts />} />
              <Route path="account" element={<AccountDetail />} />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/organization"
              element={
                <Frame {...props} hideFooter>
                  <Account />
                </Frame>
              }
            >
              {/* <Route path=":accountId" element={<AccountDetail />} /> */}
              <Route path="account" element={<AccountDetail />} />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/cred"
              element={
                <Frame {...props} hideSideMenu>
                  <CredMain />
                </Frame>
              }
            >
              <Route path="no-permission" element={<NoPermission />} />
              <Route path="*" element={<OuPreSelection />} />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/webssh"
              element={
                <Frame {...props} hideSideMenu hideHeader hideFooter>
                  <WebSSH />
                </Frame>
              }
            />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/vm-retention"
              element={
                <Frame {...props} hideSideMenu>
                  <Retention server={server} />
                </Frame>
              }
            />
          </Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Routing;
